export default function (type, color) {
    if (type === 'bg') {
        switch (color) {
            case 'green':
                return 'bg-green-5'
            case 'orange':
                return 'bg-orange-5'
            case 'red':
                return 'bg-red-5'
            default:
                return 'bg-light-3';
        }
    }
    if (type === 'dot') {
        switch (color) {
            case 'green':
                return 'bg-green-1'
            case 'orange':
                return 'bg-accent-orange'
            case 'red':
                return 'bg-red-1'
            default:
                return 'bg-dark-light'
        }
    }
    if (type === 'text') {
        switch (color) {
            case 'green':
                return 'text-green-1'
            case 'orange':
                return 'text-accent-orange'
            case 'red':
                return 'text-red-1'
            default:
                return 'text-dark-light'
        }
    }
    if (type === 'fill') {
        switch (color) {
            case 'green':
                return 'fill-green-1'
            case 'orange':
                return 'fill-accent-orange'
            case 'red':
                return 'fill-red-1'
            default:
                return 'fill-dark-light'
        }
    }
    return '';
}
